import { render, staticRenderFns } from "./SafetySummaryReport.vue?vue&type=template&id=26c39764&scoped=true&"
import script from "./SafetySummaryReport.vue?vue&type=script&lang=js&"
export * from "./SafetySummaryReport.vue?vue&type=script&lang=js&"
import style0 from "./SafetySummaryReport.vue?vue&type=style&index=0&id=26c39764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c39764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26c39764')) {
      api.createRecord('26c39764', component.options)
    } else {
      api.reload('26c39764', component.options)
    }
    module.hot.accept("./SafetySummaryReport.vue?vue&type=template&id=26c39764&scoped=true&", function () {
      api.rerender('26c39764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/SafetySummaryReport.vue"
export default component.exports